import { render, staticRenderFns } from "./FormAccessRequestWorkbook.vue?vue&type=template&id=1d189918&lang=pug"
import script from "./FormAccessRequestWorkbook.vue?vue&type=script&lang=js"
export * from "./FormAccessRequestWorkbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d189918')) {
      api.createRecord('1d189918', component.options)
    } else {
      api.reload('1d189918', component.options)
    }
    module.hot.accept("./FormAccessRequestWorkbook.vue?vue&type=template&id=1d189918&lang=pug", function () {
      api.rerender('1d189918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/FormAccessRequestWorkbook.vue"
export default component.exports